import React, { useContext, useEffect, useState } from 'react'
import './TipPage.css'
import { Icon, Toast } from 'antd-mobile'
// import StaffIcon from '../Icons/StaffIcon'
import MyNavBar from '../myComponents/MyHeader/MyNavBar'
import DoubleRightIcon from '../Icons/DoubleRightIcon'
import intl from 'react-intl-universal'
import { HospitalBasicInfoContext } from '../../contexts/HospitalBasicInfo'
import request from '../../utils/request'
import MyModal from '../myComponents/MyModal/MyModal'
import { Session } from '../../contexts/Session'
import { LanguageContext } from '../../contexts/LanguageContext'
import config from '../../config'

export default function TipPage (props) {
  const HospitalBasicInfo = useContext(HospitalBasicInfoContext) // 医院基础信息context
  const SessionContext = useContext(Session) // 用户基础信息context
  const Language = useContext(LanguageContext) // 系统语言context
  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容
  const [ifShowScanButton, setIfShowScanButton] = useState(false) // 是否显示扫码按钮

  function handleOnClickScan () {
    window.wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res) {
        var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果,当返回结果为url时，说明用户扫描的是床头二维码，否则是腕带
        const reg = /(?:(https?|ftp|file):)?\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
        if (reg.test(result)) { // 扫描床头二维码
          const hisCodeStart = find(result, '/', 4) + 1
          const patPositionStart = find(result, '/', 5) + 1
          if (hisCodeStart === -1 || patPositionStart === -1) {
            setShowModal(true)
            setModalInfo(intl.get('QRCodeErr')) // 扫描了格式不正确的二维码
            return false
          }
          const sdxHisCode = window.localStorage.getItem('sdxHisCode')
          const hisCode = result.substring(hisCodeStart, patPositionStart - 1)
          //const patPosition = result.substring(patPositionStart)
          //修改处
          let patPosition = result.substring(patPositionStart)
          if (patPosition.indexOf('?') !== -1) {
            const queryString = patPosition.substring(patPosition.indexOf('?') + 1)
            const urlParams = new URLSearchParams(queryString)
            const source = urlParams.get('source')
            if (source) {
                sessionStorage.setItem('order_source', source)
              } else {
                sessionStorage.removeItem('order_source')
              }


            patPosition = patPosition.substring(0, patPosition.indexOf('?'))
          }else {
            sessionStorage.removeItem('order_source')
          }

          if (sdxHisCode === hisCode) {
            getPatientInfoByPatientBedId(hisCode, patPosition)
          } else {
            setShowModal(true)
            setModalInfo(intl.get('QRCodeErr2')) // 扫描了其他医院的床头二维码
          }
        } else { // 扫描的是腕带
          const sdxHisCode = window.localStorage.getItem('sdxHisCode')
          if((result).indexOf(',')>-1){
            result = result.split(',')[1]; //微信公众号在调用扫一扫功能时，一维码（条形码）在直接返回结果时会在结果前带上code_XXX,需要剔除
          }
          getPetientInfoByWristbands(sdxHisCode, result)
        }
      },
      fail: function (error) {
        console.log(error)
        setShowModal(true)
        setModalInfo(intl.get('WeiChatError'))
        // setModalInfo(JSON.stringify(error))
        // setShowModal(true)
      }
    })
  }

  useEffect(() => {
    getWXConfigInfo()
  }, [])

  /**
   * 获取字符串str中cha字符第num次出现的位置
   */
  function find (str, cha, num) {
    var x = str.indexOf(cha)
    for (var i = 0; i < num; i++) {
      x = str.indexOf(cha, x + 1)
      if (x === -1) {
        return -2
      }
    }
    return x
  }

  /**
   * 获取微信配置信息
   */
  function getWXConfigInfo () {
    Toast.loading('', 0, () => {}, true)
    const url = window.location.href.substring(0, window.location.href.indexOf('#'))
    request(`/v1/wxcommons/jsapiSignature?url=${url}`, {
      method: 'POST'
    }).then((res) => {
      if (!res.error) {
        window.wx.config({
          beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        window.wx.ready(() => {
          window.wx.checkJsApi({
            jsApiList: ['scanQRCode'],
            success: function (res) {
              console.log(res)
              setIfShowScanButton(true)
              Toast.hide()
            },
            error: function (error) {
              console.log(error)
              setIfShowScanButton(false)
              setShowModal(true)
              setModalInfo(intl.get('WeiChatError'))
              Toast.hide()
            }
          })
        })
        window.wx.error((err) => {
          setIfShowScanButton(false)
          setShowModal(true)
          setModalInfo(intl.get('WeChatError'))
          console.error('upload/UploadContainer/wx/wxError')
          console.error(JSON.stringify(err))
          Toast.hide()
        })
      } else {
        console.log(res.message)
        setIfShowScanButton(false)
        setShowModal(true)
        setModalInfo(intl.get('WeChatError'))
        Toast.hide()
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 重定向到微信授权页面
   */
  function redirectToAuth () {
    const hisCode = window.localStorage.getItem('sdxHisCode') ? window.localStorage.getItem('sdxHisCode') : ''
    const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId') ? `/${window.localStorage.getItem('sdxPatPositionId')}` : ''
    const indexUrl = `/index/${hisCode}${sdxPatPositionId}`
    Toast.info(
      intl.get('RedirectToAuth'), 2,
      () => {
        // console.log(`即将跳转${config.server}/v1/wxcommons/oauth2?return_url=%23${indexUrl}`)
        window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=%23${indexUrl}`)
        // window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=${indexUrl}`)
      }, true)
  }

  /**
   * 根据床位号获取病员信息
   */
  function getPatientInfoByPatientBedId (sdxHisCode, sdxPatPositionId) {
    request(`/v1/patients/patposition/${sdxPatPositionId}?hospitalId=${sdxHisCode}`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then(async (res) => {
      // console.log(res)
      if (!res.error) {
        if (res.data.length !== 0) {
          SessionContext.setPatientInfo(res.data)
          await SessionContext.setPatientInfoByWristband({})
        } else {
          // setShowModal(true)
          // setModalInfo('根据床位号获取病员信息为空!')
          SessionContext.setPatientInfo([])
          await SessionContext.setPatientInfoByWristband({})
          // props.history.push(`/${props.match.params.nextPage}`)
        }
        getAreasFloorsInfoByPatientBedId(sdxHisCode, sdxPatPositionId)
      } else {
        SessionContext.setPatientInfo([])
        await SessionContext.setPatientInfoByWristband({})
        if (res.code) {
          if (Number(res.code) === 1001) {
            getAreasFloorsInfoByPatientBedId(sdxHisCode, sdxPatPositionId)
          } else if (Number(res.code) === 1002) {
            getAreasFloorsInfoByPatientBedId(sdxHisCode, sdxPatPositionId)
          } else if (Number(res.code) === 1003) {
            getAreasFloorsInfoByPatientBedId(sdxHisCode, sdxPatPositionId)
          } else if (Number(res.code) === 2000) {
            redirectToAuth()
          } else {
            setShowModal(true)
            setModalInfo(intl.get('ReScan'))
            SessionContext.setPositionInfo({})
            console.log(res.message)
          }
        } else {
          setShowModal(true)
          setModalInfo(intl.get('ReScan'))
          SessionContext.setPositionInfo({})
          console.log(res.message)
        }
        // Toast.info('根据床位号获取病员信息失败!')
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 根据床位号获取病区，楼层信息
   */
  function getAreasFloorsInfoByPatientBedId (sdxHisCode, sdxPatPositionId) {
    request(`/v1/hospitals/${sdxHisCode}/lc/bq/patposition/${sdxPatPositionId}`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      // console.log(res)
      if (!res.error) {
        if (!res.data) {
          // setShowModal(true)
          // setModalInfo('根据床位号获取病区，楼层信息为空!')
          setShowModal(true)
          setModalInfo(intl.get('ReScan'))
          SessionContext.setPositionInfo({})
        } else {
          SessionContext.setPositionInfo(res.data)
          props.history.push(`/${props.match.params.nextPage}`)
        }
      } else if (res.code) {
        if (Number(res.code) === 2000) {
          redirectToAuth()
        }
      } else {
        setShowModal(true)
        setModalInfo(intl.get('ReScan'))
        SessionContext.setPositionInfo({})
        console.log(res.message)
        // Toast.info(res.message)
        // Toast.info('根据床位号获取病区，楼层信息失败!')
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 根据腕带数据获取病员信息
   */
  function getPetientInfoByWristbands (sdxHisCode, result) {
    if (result.indexOf('#') !== -1) {
      result = result.replace(/#/g, '%23')
    }
    request(`/v1/patients/wristbands/${result}?hospitalId=${sdxHisCode}`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then(async (res) => {
      if (!res.error) {
        await SessionContext.setPatientInfo([])
        await SessionContext.setPatientInfoByWristband(res.data)
        await SessionContext.setPositionInfo({})
        props.history.push(`/${props.match.params.nextPage}`)
      } else if (res.code) {
        if (Number(res.code) === 2000) {
          redirectToAuth()
        } else {
          await SessionContext.setPatientInfo([])
          await SessionContext.setPatientInfoByWristband({})
          await SessionContext.setPositionInfo({})
          if (res.code) {
            if (Number(res.code) === 1001) {
              setShowModal(true)
              setModalInfo(res.message)
            } else if (Number(res.code) === 1002) {
              setShowModal(true)
              setModalInfo(res.message)
            } else if (Number(res.code) === 1003) {
              setShowModal(true)
              setModalInfo(res.message)
            } else {
              setShowModal(true)
              setModalInfo(intl.get('ReScan'))
              console.log(res.message)
            }
          }
        }
      } else {
        setShowModal(true)
        setModalInfo(intl.get('ReScan'))
        console.log(res.message)
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 点击手动录入触发
   */
  function handleOnManualInput () {
    SessionContext.setPatientInfo([])
    SessionContext.setPositionInfo({})
    SessionContext.setPatientInfoByWristband({})
    props.history.push(`/${props.match.params.nextPage}`)
  }

  return (
    <div className={'tipPageContainer'}>
      <MyNavBar
        history={props.history}
        style={{ backgroundColor: 'white' }}
        titleStyle={{ color: 'black', fontSize: '1.3rem', flex: 4 }}
        Icon={<Icon color={'black'} type={'left'} size={'lg'} />}
        rightContent={<Icon color={'black'} type={'cross'} size={'lg'} />}
      >
        {intl.get('Tips')}
      </MyNavBar>
      {
        HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo
          ? !HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isScanQRCode
            // ? <img className={'tipPageImg'} src={require('../../images/Wristband.png')} />
            ? <img className={'tipPageImg'} src={require('../../images/Wristband.jpg')} />
            // : <img className={'tipPageImg'} src={require('../../images/QRCode.png')} />
            : <img className={'tipPageImg'} src={require('../../images/QRCode.jpg')} />
          : null
      }

      <div className={'contentContainer'}>
        {/* <div className={'serviceNumber'}>
          <StaffIcon width={'7%'} color={'#FAA9AD'} />
          <p style={{ marginLeft: '10%' }}>
            {intl.get('Service Hotline')}: {HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo ? HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.phone : '暂时无法获取'}
          </p>
        </div> */}
        <div className={'tipTextContainer'}>
          <p>
            {
              HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo
                ? !HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isScanQRCode
                  ? intl.get('TipWristbandText')
                  : intl.get('TipORCdeText')
                : null
            }
          </p>
        </div>
        { ifShowScanButton ? <div
          onClick={() => handleOnClickScan()}
          className={'scanContainer'}>
          <div className={'scanButton'}>
            {intl.get('Scan')}
          </div>
        </div> : null
        }
      </div>
      <div className={'skipIconContainer'} onClick={() => handleOnManualInput()}>
        <div style={{ color: '#F87980', fontSize: '1.2rem', marginRight: '10px' }}>
          {intl.get('ManualInput')}
        </div>
        <DoubleRightIcon width={25} height={20} />
      </div>
      <MyModal
        visible={showModal}
        info={modalInfo}
        cancelButtonVisible={false}
        onOkClick={() => {
          setShowModal(false)
          // props.history.push(`/${props.match.params.nextPage}`)
        }}
      />
      {/* <div onClick={() => getPetientInfoByWristbands('CN065321', 'WD#1707290500#1')}>点击模拟腕带扫描--病员已出院</div>
      <div onClick={() => getPetientInfoByWristbands('CN065321', 'WD#1707290500#2')}>点击模拟腕带扫描--病员数据无效</div>
      <div onClick={() => getPetientInfoByWristbands('CN065321', 'WD#1700009809#1')}>点击模拟腕带扫描--病员数据有效</div>
      <div onClick={() => getPatientInfoByPatientBedId('CN065321', '5b487930aa434cf69c0ccaa05f4d692d222')}>模拟测试床头二维码--0个病员扫描</div>
      <div onClick={() => getPatientInfoByPatientBedId('CN065321', '0499e3df1a054bd49fe07ae91ad38fe7')}>模拟测试床头二维码--多个病员扫描</div>
      <div onClick={() => getPatientInfoByPatientBedId('CN065321', '938665809d3a47dc9f92effb6e3a2615')}>模拟测试床头二维码--1个病员扫描</div>
      <div onClick={() => getPatientInfoByPatientBedId('CN065321x', '938665809d3a47dc9f92effb6e3a2615')}>模拟测试床头二维码--其他医院的床头二维码</div> */}
    </div>
  )
}
